import axios from "axios";
import { NotificationSQNPIService } from "./service";
import { keycloak } from "../../../../lib/keycloak";
import { CreateNotSQNPIDTO, filtersDTO, NotSQNPIDTO, NotSQNPIDTOResponse, UpdateNotSQNPIDTO } from "./dto";

export class NotificationSQNPIServiceImpl implements NotificationSQNPIService {

    public GetAllNotificationSQNPI(filters: filtersDTO): Promise<NotSQNPIDTOResponse> {
        return axios.get("/api/sqnpi-notification", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                active: filters.active
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public UpdateNotSQNPI(data: UpdateNotSQNPIDTO, id: string): Promise<void> {
        return axios.put("/api/sqnpi-notification/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public CreateNotSQNPI(data: CreateNotSQNPIDTO): Promise<void> {
        return axios.post("/api/sqnpi-notification",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }
}